export default {
  ['logout'](state, payload) {
    Object.assign(state, payload)
  },
}
